import { render, staticRenderFns } from "./TicketCheckoutOrderSummary.vue?vue&type=template&id=c2443fd8&"
import script from "./TicketCheckoutOrderSummary.vue?vue&type=script&lang=ts&"
export * from "./TicketCheckoutOrderSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports